import { render, staticRenderFns } from "./ShoppingPlayModel.vue?vue&type=template&id=dea778c6&scoped=true"
import script from "./ShoppingPlayModel.vue?vue&type=script&lang=js"
export * from "./ShoppingPlayModel.vue?vue&type=script&lang=js"
import style0 from "./ShoppingPlayModel.vue?vue&type=style&index=0&id=dea778c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea778c6",
  null
  
)

export default component.exports